function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 140,
    viewBox: "0 0 31.749999 37.041666",
    id: "svg1",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ededed",
      stroke: "none"
    },
    d: "m 9.7895826,19.050006 c 0.18389,1.83487 1.7268504,3.98139 0.7463904,5.80654 -1.8304204,3.40735 -7.5573324,4.62669 -10.50027339,6.50775 L -3.9285714e-7,37.041666 H 31.75 l -0.02138,-8.60125 c -2.260165,-0.82143 -8.993742,-1.17416 -10.224692,-5.15728 -0.36646,-1.18579 0.45277,-2.94079 0.45648,-4.23313 1.98379,-0.58029 1.03933,-3.79251 1.14286,-5.29167 0.0923,-1.33612 0.83817,-2.61655 0.66758,-3.9687503 -0.37165,-2.94588 -4.3509,-6.65659 -7.36669,-6.59376 -5.90222,0.12296 -9.6355304,3.98769 -8.5805804,9.7687603 0.3263,1.78808 -0.57905,5.76729 1.966,6.08542 z",
    id: "path2"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/client.7e074296bf4859db0326c121384f83bd.svg";
export { ForwardRef as ReactComponent };